import { Component,HostListener,  OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbdSortableHeader, SortEvent } from '../../../../shared/directives/NgbdSortableHeader';

import { Observable } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';
import { PropietarioService } from '../../../../shared/services/propietarios.service';
import { Router } from '@angular/router';


import jsPDF from 'jspdf';
import { Utils } from '../../../../shared/utils/Utils';
const Swal = require("sweetalert2");

@Component({
  selector: 'app-inactivos',
  templateUrl: './inactivos.component.html',
  styleUrls: ['./inactivos.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InactivosComponent implements OnInit {

  public selected = [];

  public searchText = ''; // Texto para búsqueda
  total$: Observable<number>; // Observable para obtener el total de elementos
  propietarios: any[] = [];
  loading: boolean = false;

  public show : boolean = false
  openDropdown: any = null; // Variable para controlar qué menú está abierto
  openDropdown2: any = null; // Variable para controlar qué menú está abierto
  sortColumn: string = '';
  sortDirection: string = 'asc'; // 'asc' o 'desc'
  searchTerm: string = '';
  dropdownStates: boolean[] = [];
  filteredTableItems: PropietarioService[];
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>; // Para la cabecera de la tabla

  constructor(private propietarioService: PropietarioService,private router: Router) {}

  ngOnInit() {

    this.listarPropietariosInactivos();
    
  }

  pageSize: number = 5; 
  page: number = 1;
  totalItems: number;

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    this.openDropdown = null;
    this.openDropdown2 = null;
  }

  stopPropagation(event: Event) {
    event.stopPropagation(); // Evita que el clic dentro del dropdown cierre el menú
  }
  // Función para ordenar las columnas
  onSort({ column, direction }: SortEvent) {
    // Restablecemos la dirección de orden de todas las columnas
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

   
  }


  get filteredPropietarios() {
    if (!this.searchTerm) {
      return this.propietarios; // Mostrar todos los datos si no hay búsqueda
    }

    const term = this.searchTerm.toLowerCase();
    return this.propietarios.filter(propietario => {
      // Ajusta los campos por los que quieres buscar
      return (
        propietario.primernombre.toLowerCase().includes(term) ||
        propietario.segundonombre.toLowerCase().includes(term) ||
        propietario.papellidos.toLowerCase().includes(term) ||
        propietario.seapellidos.toLowerCase().includes(term) ||
        propietario.cedula.toLowerCase().includes(term) ||
        propietario.mail.toLowerCase().includes(term) ||
        propietario.numerolic.toLowerCase().includes(term) ||
        propietario.direccion.toLowerCase().includes(term) ||
        propietario.cargoData.cargos.toLowerCase().includes(term) ||
        propietario.condicionLaboral.label.toLowerCase().includes(term) ||
        propietario.telfijo.toLowerCase().includes(term) ||
        propietario.telcel.toLowerCase().includes(term)
      );
    });
  }

  toggleDropdown(index: number) {
    this.dropdownStates = this.dropdownStates.map((state, i) => (i === index ? !state : false));
  }

  listarPropietariosInactivos(): void {
    this.loading = true;
    this.propietarioService.getPropietariosInactivos().subscribe({
      next: (data) => {
        if (data?.propietarios) {
          if (data?.propietarios) {
          this.propietarios = data.propietarios;
        }
         
            this.filteredTableItems = [...this.propietarios];

        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error cargando propietarios', err);
        this.loading = false;
      }
    });
  }

  //recibe el id de la tabla vista, nombre con el que descargará el archivo, titulo del documento
 exportToPDF(tableId:string,nameFile:string,titleFile:string) {
  Utils.exportToPDF(tableId, nameFile,titleFile);
  }


  exportarExcel(tableId:string,nameFile:string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }
 
  activarPersona(idPersona:string){
   // console.log(idPersona);
    this.avisoActivarPersona(idPersona);
  }

  avisoActivarPersona(idPersona: string) {
  Swal.fire({
    title: "ACTIVAR",
    text: `¿Desea activar a la persona con NIP: ${idPersona}?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Aceptar",
    cancelButtonText: "Cancelar",
  }).then((result) => {
    if (result.isConfirmed) {
      // Mostrar loader
      Swal.fire({
        title: 'Activando...',
        text: 'Por favor espera',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      this.propietarioService.updatePropietariosEstado(idPersona, 1).subscribe({
        next: (response) => {
          Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: response.message,
            confirmButtonText: 'Aceptar'
          });

          this.listarPropietariosInactivos();
        },
        error: (error) => {
          console.error('Error:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo activar la persona. Intenta nuevamente.',
            confirmButtonText: 'Aceptar'
          });
        }
      });
    }
  });
}
  sortData(column: string) {
  if (this.sortColumn === column) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    this.sortColumn = column;
    this.sortDirection = 'asc';
  }

  const listToSort = this.filteredTableItems.length ? this.filteredTableItems : this.propietarios;

  listToSort.sort((a, b) => {
    let aVal = this.getNestedValue(a, column);
    let bVal = this.getNestedValue(b, column);

    if (typeof aVal === 'string') aVal = aVal.toLowerCase();
    if (typeof bVal === 'string') bVal = bVal.toLowerCase();

    if (aVal < bVal) return this.sortDirection === 'asc' ? -1 : 1;
    if (aVal > bVal) return this.sortDirection === 'asc' ? 1 : -1;
    return 0;
  });

  this.page = 1; // Reiniciar paginación
}

getNestedValue(obj: any, path: string): any {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj) ?? '';
}

 filterData() {
    const search = this.searchText.trim().toLowerCase();
    if (!search) {
      this.filteredTableItems = [...this.propietarios];
    } else {
      this.filteredTableItems = this.propietarios.filter((item) =>
        (
          (item.primernombre || ' ') +
          (item.segundonombre || ' ') +
          (item.papellidos || ' ') +
          (item.seapellidos || ' ') +
          (item.cedula || ' ') +
          (item.cargoData.cargos || ' ') +
          (item.mail || ' ') +
          (item.telcel || ' ')
        )
          .toLowerCase()
          .includes(search)
      );
    }
    this.page = 1; // Reiniciar a la primera página
  }

   editarPersona(idPersona:string){
     console.log(idPersona);
    // this.router.navigate(['/persona/editar']);
     this.router.navigate(['/persona/editar', idPersona]);
   }

}
